export function formatInternalNoteAuthor(note) {
  const fullName = note?.user?.full_name?.trim();
  if (fullName) {
    return fullName;
  }

  const name = [note?.user?.first_name, note?.user?.last_name]
    .filter((value) => typeof value === "string" && value.trim())
    .map((value) => value.trim())
    .join(" ");

  if (name) {
    return name;
  }

  return Number(note?.created_by) === 0 ? "System" : "Unknown user";
}
